function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IS_OPENED_CLASS = 'is-opened';
var ARIA_EXPANDED = 'aria-expanded';
var FILTER_SELECT_MENU = '[data-element="filterSelectMenu"]';
var FILTER_SELECT_BUTTON = '[data-element="filterSelectButton"]';
var FILTER_SELECT_CTA = '[data-element="filterSelectCta"]';
var SelectComponent = /*#__PURE__*/function () {
  function SelectComponent(component, selector) {
    _classCallCheck(this, SelectComponent);
    this.component = component;
    this.selector = selector;
    this.button = this.component.querySelector(FILTER_SELECT_BUTTON);
    this.menu = this.component.querySelector(FILTER_SELECT_MENU);
    this.inputField = this.component.querySelector('[data-element="filterSelectInputField"]');
    this.menuCtas = Array.from(this.menu.querySelectorAll(FILTER_SELECT_CTA));
    this.autoClose = this.autoClose.bind(this);
    this.closeOnEsc = this.closeOnEsc.bind(this);
    this.button.addEventListener('click', this.toggle.bind(this));
    this.component.style.opacity = 1;
    this.component.style.visibility = 'visible';
  }
  return _createClass(SelectComponent, [{
    key: "closeRestFilters",
    value: function closeRestFilters() {
      var _this = this;
      Array.from(document.querySelectorAll(this.selector)).forEach(function (item) {
        if (item !== _this.component) {
          item.classList.remove(IS_OPENED_CLASS);
          item.querySelector(FILTER_SELECT_BUTTON).setAttribute(ARIA_EXPANDED, false);
        }
      });
    }
  }, {
    key: "autoClose",
    value: function autoClose(event) {
      if (!event.target.closest(this.selector)) {
        this.close();
      }
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(event) {
      if (event.key === 'Escape') {
        this.close();
        document.body.removeEventListener('keydown', this.closeOnEsc);
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.component.classList.add(IS_OPENED_CLASS);
      this.button.setAttribute(ARIA_EXPANDED, true);
      this.closeRestFilters();
      document.body.addEventListener('keydown', this.closeOnEsc);
      document.body.addEventListener('click', this.autoClose);
    }
  }, {
    key: "close",
    value: function close() {
      this.component.classList.remove(IS_OPENED_CLASS);
      this.button.setAttribute(ARIA_EXPANDED, false);
      document.body.removeEventListener('click', this.autoClose);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.component.matches(".".concat(IS_OPENED_CLASS))) {
        this.close();
      } else {
        this.open();
      }
    }
  }]);
}();
export { SelectComponent as default };